<template>
    <painel titulo="Solicitação de documentos da empresa" icon="pi pi-copy">
        <btn-voltar class="mt-2" @click="voltar()" />

        <btn-documentacao-recebida class="ml-2" @voltarParaDetalhamento="voltar()" />
    </painel>
</template>

<script>
import BtnDocumentacaoRecebida from './BtnDocumentacaoRecebida.vue';

export default {
    components: {
        BtnDocumentacaoRecebida,
    },

    methods: {
        voltar() {
            this.$router.push({
                name: 'Licitacoes_Solicitacoes_Detalhar',
                params: { id: this.$route.params.id },
            });
        },
    },
};
</script>
